// non-sensitive addresses

export const GXO_WAREHOUSE_ADDRESS = {
  company: "Healf",
  warehouseCompany: "PFS-GXO Logistics",
  line1: "Unit 7 Mountpark, Wide Lane",
  city: "Southampton",
  postalCode: "SO18 2FA",
  country: "United Kingdom",
  countryCode: "GB"
};

export const ACTIVE_ANTS_WAREHOUSE_ADDRESS = {
  company: "Healf",
  warehouseCompany: "Active Ants",
  line1: "Borchwerf 5",
  city: "Roosendaal",
  postalCode: "4704 RG",
  country: "Netherlands",
  countryCode: "NL"
};
